module.exports = __webpack_public_path__ + "img/DS.49207aa7.jpg";